module.exports = __webpack_public_path__ + "img/symbol_11.cf04dd92.png";